export default __webpack_public_path__ + "static/media/DragIcon.ea874651.svg";